'use client'

// src/useCountDown.ts
import { useCallback, useEffect, useMemo, useState } from "react";
var countDownIntervals = {};
var getDestinationSeconds = (seconds) => Date.now() + seconds * 1e3;
var useCountDown = ({ id, initialSeconds = 60 }) => {
  const [durationSeconds, setDurationSeconds] = useState(
    () => getDestinationSeconds(initialSeconds)
  );
  const [count, setCount] = useState(initialSeconds);
  const set = (n) => {
    clearInterval(countDownIntervals[id]);
    setDurationSeconds(getDestinationSeconds(n));
    setCount(n);
    init();
  };
  const setSeconds = (seconds) => {
    clearInterval(countDownIntervals[id]);
    setDurationSeconds(getDestinationSeconds(seconds));
    setCount(seconds);
    init();
  };
  const reset = () => {
    clearInterval(countDownIntervals[id]);
    setDurationSeconds(getDestinationSeconds(initialSeconds));
    setCount(initialSeconds);
    init();
  };
  const stop = () => {
    clearInterval(countDownIntervals[id]);
    setCount(0);
  };
  const decrease = useCallback(() => {
    setCount((prev) => {
      if (prev <= 1) {
        clearInterval(countDownIntervals[id]);
      }
      return prev <= 1 ? 0 : prev - 1;
    });
  }, [id]);
  const init = useCallback(() => {
    countDownIntervals[id] = setInterval(decrease, 1e3);
  }, [decrease, id]);
  useEffect(() => {
    init();
    return () => clearInterval(countDownIntervals[id]);
  }, [init]);
  const timer = useMemo(() => {
    const distance = durationSeconds - Date.now();
    return {
      days: Math.floor(distance / (1e3 * 60 * 60 * 24)),
      hours: Math.floor(distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)),
      minutes: Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60)),
      seconds: Math.floor(distance % (1e3 * 60) / 1e3)
    };
  }, [count, durationSeconds]);
  return {
    timer,
    isTimeUp: timer.days <= 0 && timer.hours <= 0 && timer.minutes <= 0 && timer.seconds <= 0,
    count,
    reset,
    set,
    setSeconds,
    stop
  };
};

export {
  useCountDown
};
//# sourceMappingURL=chunk-IQJZD57A.mjs.map